import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { urlModifier } from 'swag-client-common/libs/url-modifier';
import { HEADER_BRANDS_LINE_SIZE } from 'swag-client-common/constants';
import { LogoCategories } from '../logo-categories';
import anim from './anim.scss';
import classes from './subcategories-links.scss';
function getLinesCount(subcat = []) {
  const logosToShow = subcat.slice(0, 27);
  const count = Math.ceil(logosToShow.length / HEADER_BRANDS_LINE_SIZE) || 1;
  return count;
}
const TextCategories = ({
  currentSubcategoryId,
  currentRoute,
  parentCategory,
  isViolet,
  onLinkClick,
  subcategories,
  shouldShow
}) => {
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Link, {
    className: classnames(classes.subMenuItem, {
      [classes.activeMenuItem]: currentSubcategoryId === null,
      [classes.violet]: isViolet
    }),
    to: urlModifier(`/${currentRoute}/${parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.slug}`),
    onClick: () => onLinkClick(currentSubcategoryId === null)
  }, `All ${parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name}`), (subcategories || []).map(subcat => {
    if (!subcat.isVisible) {
      return null;
    }
    const isActive = subcat._id === currentSubcategoryId;
    return /*#__PURE__*/React.createElement(Link, {
      key: subcat._id,
      className: classnames(classes.subMenuItem, {
        [classes.activeMenuItem]: isActive,
        [classes.violet]: isViolet
      }),
      to: urlModifier(`/${currentRoute}/${subcat.slug}`),
      onClick: () => onLinkClick(isActive)
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.linkName
    }, subcat.name));
  }));
};
export const SubcategoriesLinksComponent = ({
  subcategories,
  currentRoute,
  currentMainCategory,
  currentSubcategoryId,
  parentCategory,
  isViolet = false,
  wrapperClassName = '',
  onLinkClick,
  isFilterOpened,
  isLogoCategory,
  isOneline,
  handleMouseEnter,
  shouldShow
}) => {
  const linesCount = !isLogoCategory || isOneline ? 1 : getLinesCount(subcategories);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.subMenu, wrapperClassName, {
      [classes.isFilterOpened]: isFilterOpened,
      [classes.hidden]: !shouldShow,
      [classes[`logoMenu${linesCount}`]]: isLogoCategory
    }),
    "data-id": parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory._id,
    onMouseEnter: handleMouseEnter
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: 150,
    in: shouldShow,
    key: (parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name) || '',
    classNames: anim,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, isLogoCategory ? /*#__PURE__*/React.createElement(LogoCategories, {
    subcategories: subcategories,
    currentRoute: currentRoute,
    currentMainCategory: currentMainCategory,
    currentSubcategoryId: currentSubcategoryId,
    parentCategory: parentCategory,
    onLinkClick: onLinkClick,
    isOneline: isOneline
  }) : /*#__PURE__*/React.createElement(TextCategories, {
    currentSubcategoryId: currentSubcategoryId,
    currentRoute: currentRoute,
    parentCategory: parentCategory,
    isViolet: isViolet,
    onLinkClick: onLinkClick,
    subcategories: subcategories,
    shouldShow: shouldShow
  })))));
};